import { getUserValuesFromLocalStorage } from 'common/Utils/LocalStorageUtilities'
import Modal from 'components/Common/Modal/Modal'
import SimpleTable from 'components/Common/SimpleTable'
import { PRODUCTION_DELIVERED_DHL } from 'constants/productionStatusDHL'
import { USER_ROLE_BOSS, USER_ROLE_MANAGER, USER_ROLE_SUPPLIER } from 'constants/userRoles'
import { Tracking } from 'pages/SupplierProduction/Tracking'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { getProductionsPickedUpByCourier } from 'store/actions'


const GlobalWarningOrderNotReceivedModal = ({
	t,
	i18n: { language },
	productionsPickedUpByCourier,
	getProductionsPickedUpByCourier,
}) => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [modalMessage, setModalMessage] = useState('')
	const userValues = getUserValuesFromLocalStorage()
	useEffect(() => {
		if (productionsPickedUpByCourier.length === 0 && userValues != null) {
			getProductionsPickedUpByCourier()
		}
	}, [])

	useEffect(() => {
		if (userValues == null || localStorage.getItem('testing')) return
		const now = new Date()
		const isAfter4PM = now.getHours() >= 16
		if (!isAfter4PM) {
			localStorage.removeItem('shownFragmentIds')
		}

		if (isAfter4PM) {
			const shownFragmentIds = new Set(JSON.parse(localStorage.getItem('shownFragmentIds') || '[]'))

			const pendingProductions = productionsPickedUpByCourier.filter(production =>
				production.production.statusDhl === PRODUCTION_DELIVERED_DHL && !shownFragmentIds.has(production.production.displayId)
			)

			if (pendingProductions.length > 0) {

				const userRoles = userValues.roles || []
				const userId = userValues.id

				let shouldShowModal = false

				if (userRoles.includes(USER_ROLE_MANAGER) || userRoles.includes(USER_ROLE_BOSS)) {
					shouldShowModal = true
				} else if (userRoles.includes(USER_ROLE_SUPPLIER)) {
					shouldShowModal = pendingProductions.some(production => production.production.supplierId === userId)
				}

				if (shouldShowModal) {
					const message = pendingProductions.length === 1
						? (
							<span>
								{t('the_production', { ns: 'naming' })} {t('message_order_not_received', { ns: 'naming' })}
							</span>
						)
						: (
							<span>
								{t('the_productions', { ns: 'naming' })} {t('message_orders_not_received', { ns: 'naming' })}
							</span>
						)
					setModalMessage(message)
					setIsModalOpen(true)

					const newShownFragmentIds = Array.from(shownFragmentIds).concat(pendingProductions.map(production => production.production.displayId))
					localStorage.setItem('shownFragmentIds', JSON.stringify(newShownFragmentIds))
				}
			}
		}
	}, [productionsPickedUpByCourier])

	const closeModal = () => {
		setIsModalOpen(false)
	}

	const getTableBody = () => {
		const productionsToShow = productionsPickedUpByCourier.filter(production =>
			production.production.statusDhl === PRODUCTION_DELIVERED_DHL
		)
		return productionsToShow.map(({ production }) => {
			return (
				<tr>
					<td>
						<div>
							<p>{production?.displayId}</p>
						</div>
					</td>

					<td>
						<Tracking
							trackingId={production?.shipmentTrackingNumber}
							courier={production?.courier}
							estimatedArrivalDate={production?.arrivalDateEstimated}
							status={production?.statusId}
							incidenceShipmentWarning={true}
						/>
					</td>

				</tr>)
		})
	}
	const header = ['production', 'tracking']
	return (
		<div className='d-flex'>
			<div>
				<Modal
					title={t('production_not_received', { ns: 'naming' })}
					body={
						<div className='p-4'>
							<div className='d-flex flex-column'>
								<p>{modalMessage}</p>
								<SimpleTable header={header} getTableBody={getTableBody} />
							</div>
						</div>
					}
					isOpen={isModalOpen}
					closeModal={closeModal}
				/>
			</div>
		</div>
	)
}


GlobalWarningOrderNotReceivedModal.propTypes = {
	t: PropTypes.func,
	productionsPickedUpByCourier: PropTypes.array,
	getProductionsPickedUpByCourier: PropTypes.func,
}

const mapStateToProps = (state) => ({
	productionsPickedUpByCourier: state.Productions.productionsPickedUpByCourier,
})

const mapDispatchToProps = {
	getProductionsPickedUpByCourier,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GlobalWarningOrderNotReceivedModal))
